// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ba-section {
    padding: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;
    background-color: white;
}
/* Image */
.ba-image-content {
    width: 50%;
    max-width: 100%;
    text-align: center;
}
.ba-image1 {
    width: 80%;
    height: auto;
    border-radius: 16px;
    object-fit: cover;
}
/* Text */
.ba-text-content {
    width: 50%;
}
.ba-title {
    font-family: 'Inter', sans-serif;
    font-size: 40px;
    font-weight: bold;
    letter-spacing: .7px;
}
.ba-title > span {
    position: relative;
}
.ba-title span::before {
    content: '';
    position: absolute;
    width: 75%;
    height: 4px;
    background-color: #9D2553;
    border-radius: 8px;
    left: 0;
    bottom: -12px;
}
.ba-description {
    margin: 32px 0;
    color: #4d4b4b;
    font-family: 'Inter', sans-serif;
    font-size: 18px;
    letter-spacing: .8px;
    line-height: 1.8rem;
}
/* Checks */
.ba-checks {
    margin: 28px 0;
    font-family: 'Inter', sans-serif;
    font-size: 22px;
    font-weight: bold;
    letter-spacing: .7px;
}
.ba-check-first {
    margin-top: 40px;
}
.ba-check-last {
    margin-bottom: 40px;
}
/* Book Appointment Button */
.ba-appointment-btn {
    padding: 18px 24px;
    color: white;
    border: 1px solid transparent;
    border-radius: 50px;
    outline: transparent;
    background-color: #2e5288;
    font-size: 20px;
    font-family: 'Inter', sans-serif;
    letter-spacing: .8px;
    cursor: pointer;
    transition: all .4s ease;
}
.ba-appointment-btn:hover {
    color: #2e5288;
    background-color: transparent;
    border: 1px solid #2e5288;
}
/* Responsive */
@media screen and (max-width: 1000px) {
    .ba-section {
        display: block;
    }
    .ba-image-content {
        width: 100%;
        max-width: 100%;
        margin: 0 0 32px 0;
    }
    .ba-text-content {
        width: 100%;
    }
    .ba-image1 {
        width: 80%;
        height: 80%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/BookAppointment.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,uBAAuB;AAC3B;AACA,UAAU;AACV;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;AACA,SAAS;AACT;IACI,UAAU;AACd;AACA;IACI,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,OAAO;IACP,aAAa;AACjB;AACA;IACI,cAAc;IACd,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,oBAAoB;IACpB,mBAAmB;AACvB;AACA,WAAW;AACX;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,mBAAmB;IACnB,oBAAoB;IACpB,yBAAyB;IACzB,eAAe;IACf,gCAAgC;IAChC,oBAAoB;IACpB,eAAe;IACf,wBAAwB;AAC5B;AACA;IACI,cAAc;IACd,6BAA6B;IAC7B,yBAAyB;AAC7B;AACA,eAAe;AACf;IACI;QACI,cAAc;IAClB;IACA;QACI,WAAW;QACX,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,WAAW;IACf;IACA;QACI,UAAU;QACV,WAAW;IACf;AACJ","sourcesContent":[".ba-section {\n    padding: 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 24px;\n    background-color: white;\n}\n/* Image */\n.ba-image-content {\n    width: 50%;\n    max-width: 100%;\n    text-align: center;\n}\n.ba-image1 {\n    width: 80%;\n    height: auto;\n    border-radius: 16px;\n    object-fit: cover;\n}\n/* Text */\n.ba-text-content {\n    width: 50%;\n}\n.ba-title {\n    font-family: 'Inter', sans-serif;\n    font-size: 40px;\n    font-weight: bold;\n    letter-spacing: .7px;\n}\n.ba-title > span {\n    position: relative;\n}\n.ba-title span::before {\n    content: '';\n    position: absolute;\n    width: 75%;\n    height: 4px;\n    background-color: #9D2553;\n    border-radius: 8px;\n    left: 0;\n    bottom: -12px;\n}\n.ba-description {\n    margin: 32px 0;\n    color: #4d4b4b;\n    font-family: 'Inter', sans-serif;\n    font-size: 18px;\n    letter-spacing: .8px;\n    line-height: 1.8rem;\n}\n/* Checks */\n.ba-checks {\n    margin: 28px 0;\n    font-family: 'Inter', sans-serif;\n    font-size: 22px;\n    font-weight: bold;\n    letter-spacing: .7px;\n}\n.ba-check-first {\n    margin-top: 40px;\n}\n.ba-check-last {\n    margin-bottom: 40px;\n}\n/* Book Appointment Button */\n.ba-appointment-btn {\n    padding: 18px 24px;\n    color: white;\n    border: 1px solid transparent;\n    border-radius: 50px;\n    outline: transparent;\n    background-color: #2e5288;\n    font-size: 20px;\n    font-family: 'Inter', sans-serif;\n    letter-spacing: .8px;\n    cursor: pointer;\n    transition: all .4s ease;\n}\n.ba-appointment-btn:hover {\n    color: #2e5288;\n    background-color: transparent;\n    border: 1px solid #2e5288;\n}\n/* Responsive */\n@media screen and (max-width: 1000px) {\n    .ba-section {\n        display: block;\n    }\n    .ba-image-content {\n        width: 100%;\n        max-width: 100%;\n        margin: 0 0 32px 0;\n    }\n    .ba-text-content {\n        width: 100%;\n    }\n    .ba-image1 {\n        width: 80%;\n        height: 80%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
